import { render } from "./LegalPolicy.vue?vue&type=template&id=4f277a8c&ts=true"
import script from "./LegalPolicy.vue?vue&type=script&lang=ts"
export * from "./LegalPolicy.vue?vue&type=script&lang=ts"

import "./LegalPolicy.vue?vue&type=style&index=0&id=4f277a8c&lang=css"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__